import React from "react";
import {cn} from "@/ReactInit/Scripts/DashboardPage/utils/dashboardHelpers";

interface DashboardLoaderProps {
  size?: "sm" | "base" | "lg" | "xl" | "2xl" | "3xl";
  label?: string;
}

export const DashboardLoader: React.FC<DashboardLoaderProps> = ({size = "xl", label = "Laster inn…"}) => {
  const loaderSize = () => {
    switch (size) {
      case "sm":
        return "text-sm";
      case "base":
        return "text-base";
      case "lg":
        return "text-lg";
      case "xl":
        return "text-xl";
      case "2xl":
        return "text-2xl";
      case "3xl":
        return "text-3xl";
    }
  }

  return (
    <div
      className={cn(
        loaderSize(),
        "flex flex-row py-20 gap-2 w-full mx-auto max-w-[932px] min-h-32 items-center justify-center"
      )}
    >
      <div className="icon-loader icon-spinner animate-spin" aria-hidden="true"/>
      <span>{label}</span>
    </div>
  )
}